import React, { createRef } from 'react';
import { CenteredModalProps } from './types';

export function CenteredModal(props: CenteredModalProps) {
  const backdropRef = createRef<HTMLDivElement>();

  if (!props.showModal) {
    return null;
  }

  function handleBackdropClick(event) {
    if (!props.handleCloseModal) {
      return;
    }

    if (event.target !== backdropRef.current) {
      return;
    }

    event.stopPropagation();
    props.handleCloseModal();
  }

  return (
    <div
      className={'modal centered-modal fade show ' + (props.forceNotWide ? '' : 'modal-wide')}
      ref={backdropRef}
      onClick={handleBackdropClick}
    >
      <div className={`modal-content ${props.contentClassName ?? ''}`.trim()}>
        {props.handleCloseModal && (
          <div className="modal-close" onClick={() => props.handleCloseModal!()}>
            <i className="fas fa-xmark"></i>
          </div>
        )}
        {props.children}
      </div>
    </div>
  );
}
